export default "__VITE_ASSET__8DmyqWhf__"